import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../store/actions/index'
import styles from './CrmModal.module.css'
import { Modal, Button, Form, Tabs, Tab, Row, Col } from 'react-bootstrap';
// import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ModuleBuilder from './ModuleBuilder/ModuleBuilder';
import ModuleRecords from './ModuleRecords/ModuleRecords';
const CrmModal = (props) => {
    const [t] = useTranslation('crm')
    const navigate = useNavigate();
    const crmState = useSelector(state => state.crm)
    const dispatch = useDispatch()

    const { manageCrmModuleSelectedObj } = props

    const onHide = () => {
        dispatch(actions.setCrmModule())
        navigate(`/`)
    }

    let modalTitle = t(crmState.crmPath.name)
    let showBody = <ModuleRecords crmState={crmState} />
    if (crmState.crmPath.attribute === 'settings') {
        modalTitle = t('Module managment', { module: t(crmState.crmPath.name) })
        showBody = <ModuleBuilder crmState={crmState} manageCrmModuleSelectedObj={manageCrmModuleSelectedObj} />
    }

    return (
        <Modal show={true} onHide={onHide} dialogClassName={`my-modal`} size="xl" centered aria-labelledby="contained-modal-title-vcenter" className={`rtl-modal`} >
            <Modal.Header className={`${styles['modal-header']}`}>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body id='file-manager-model' className={styles[`modal-body`]} >
                {showBody}
            </Modal.Body>
            <Modal.Footer className={`${styles['modal-footer']}`}>
                <div className={`${styles['modal-footer-side']}`}>
                    <Button variant="secondary" onClick={onHide}>{t('Exit')}</Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default CrmModal